import ApiClientDefault from "@eventr/common/lib/httpRequests/httpRequest";

type ApiClientCtor = typeof ApiClientDefault;

/**
 * `@eventr/common` is CommonJS, and `lib/httpRequests/httpRequest.js` ends with
 * `exports.default = ApiClient` plus a *non-enumerable* `__esModule` marker.
 *
 * Vite's dev dependency optimizer pre-bundles that file into a shared chunk and generates
 * the entry as `export default require_httpRequest()` — which hands back `module.exports`,
 * i.e. `{ default: ApiClient }`, instead of unwrapping to the class. So a plain
 * `import ApiClient from ".../httpRequest"` yields an object and `new ApiClient()` throws
 * `TypeError: ApiClient is not a constructor` on dev-server boot. That in turn aborts
 * evaluation of `apiClients.ts`, which leaves `utils.ts` half-initialized and produces the
 * follow-on `ReferenceError: Cannot access 'Utils' before initialization` from deviceInfo.
 *
 * The production build is unaffected — it emits `new import_httpRequest.default(...)`
 * correctly — so this only bites `vite dev`. Reproduced on vite 8.2.0 and 8.2.1.
 *
 * Unwrapping defensively works under both: in dev the binding is `{ default: class }`, in
 * prod it is already the class (and a class has no `.default`, so the fallback is hit).
 *
 * Delete this shim once `@eventr/common` ships an ESM build or the optimizer unwraps.
 */
export const ApiClient: ApiClientCtor =
  (ApiClientDefault as unknown as { default?: ApiClientCtor }).default ?? ApiClientDefault;
